import React from 'react';
import { Redirect, Route, useLocation, useRouteMatch } from 'react-router-dom';
import UnderwritingApproval from './underwritingApproval/underwritingApproval.component';

export default function UnderwritingApprovalRoutersComponent() {
  const { path } = useRouteMatch();
  const location = useLocation();

  //   const hasAccess = roleService.checkRouteAccess({ location });
  const hasAccess = true;

  return hasAccess ? (
    <Route exact path={path} component={UnderwritingApproval} />
  ) : (
    <Redirect
      to={{
        pathname: '/unauthorized',
        state: { from: location },
      }}
    />
  );
}
